<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="#"><i class="fas fa-door-open"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>Restaurant v2</span></li>
                <li><span class="text-muted">Salones</span></li>
            </ol>
            <div class="right-wrapper pull-right">
                <button class="btn btn-custom btn-sm mt-2 mr-2" @click.prevent="clickCreate()">
                    <i class="fa fa-plus-circle"></i> Nuevo
                </button>
            </div>
        </div>

        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">Listado de salones</h3>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Salón</th>
                                <th>Estado</th>
                                <th class="text-right">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in records" :key="row.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ row.name }}</td>
                                <td>
                                    <el-tag :type="row.active ? 'success' : 'info'">
                                        {{ row.active ? 'Activo' : 'Inactivo' }}
                                    </el-tag>
                                </td>
                                <td class="text-right">
                                    <button class="btn btn-xs btn-info" @click.prevent="clickCreate(row)">
                                        Editar
                                    </button>
                                    <button class="btn btn-xs btn-danger" @click.prevent="clickDelete(row.id)">
                                        Eliminar
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <rooms-form
            :showDialog.sync="showDialog"
            :record="record"
            @saved="getRecords">
        </rooms-form>
    </div>
</template>

<script>
import { deletable } from '@mixins/deletable'
import RoomsForm from './form.vue'

export default {
    mixins: [deletable],
    components: { RoomsForm },
    data() {
        return {
            resource: 'restaurant/v2/rooms',
            records: [],
            showDialog: false,
            record: null,
        }
    },
    created() {
        this.getRecords()
    },
    methods: {
        getRecords() {
            this.$http.get(`/${this.resource}/records`).then(response => {
                this.records = response.data.data
            })
        },
        clickCreate(record = null) {
            this.record = record
            this.showDialog = true
        },
        clickDelete(id) {
            this.destroy(`/${this.resource}/${id}`).then(() => this.getRecords())
        },
    }
}
</script>


// WEBPACK FOOTER //
// modules/Restaurant/Resources/assets/js/views/v2/rooms/index.vue